<template>
  <section class="container mx-auto lg:grid lg:grid-cols-12 gap-x-8 v-page-section-container-padding mb-8 md:mb-12">
    <div class="col-span-full lg:col-start-2 lg:col-end-12 2xl:col-start-3 2xl:col-end-11">
      <h2
        v-if="label"
        class="col-span-full xl:col-start-2 xl:col-end-12 font-semibold leading-tight text-2xl md:text-3xl mb-4 md:mb-6"
        :class="{
          'text-white': colorTheme === 'dark-green' || colorTheme === 'petrol' || colorTheme === 'red' || colorTheme === 'violet',
          'text-app-primary-1-red--torch': colorTheme === 'blue' || colorTheme === 'light-green',
          'text-app-primary-1-red--fire-brick': colorTheme === 'pink',
        }"
      >
        {{ label }}
      </h2>
      <iframe
        v-if="widgetUrl.length > 0 && widgetHeight > 0"
        :src="iframeUrl"
        frameborder="0"
        :allow="allowAttribute"
        allowtransparency="true"
        class="w-full rounded-3xl overflow-hidden"
        :height="widgetHeight"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
function appendQueryParametersToUrl(url: string, query: CmsData) {
  const searchParams = new URLSearchParams()

  Object.entries(query || {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null) {
          searchParams.append(key, String(item))
        }
      })

      return
    }

    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  const queryString = searchParams.toString()

  if (queryString.length === 0) {
    return url
  }

  const [baseUrl = '', hash = ''] = url.split('#')
  const separator = baseUrl.includes('?') ? (baseUrl.endsWith('?') || baseUrl.endsWith('&') ? '' : '&') : '?'

  return `${baseUrl}${separator}${queryString}${hash ? `#${hash}` : ''}`
}

const props = defineProps({
  label: { type: String, required: false, default: undefined },
  widgetHeight: { type: Number, required: false, default: 100 },
  widgetUrl: { type: String, required: true },
  appendPageUrlParameters: { type: Boolean, required: false, default: false },
  colorTheme: { type: String, required: false, default: undefined },
})

const route = useRoute()
const allowAttribute = ref<string | undefined>(undefined)
const iframeUrl = computed(() => {
  if (!props.appendPageUrlParameters) {
    return props.widgetUrl
  }

  return appendQueryParametersToUrl(props.widgetUrl, route.query)
})

// create separate function if more logic is needed
if (props.widgetUrl.includes('spotify.com')) {
  allowAttribute.value = 'encrypted-media'
}
</script>
